import React from "react";
import { Download, ExternalLink } from "lucide-react";

const Hero = () => {
  const irAProyectos = () => {
    document.getElementById("proyectos")?.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <>
      <style>
        {`
          @keyframes aparecerDesdeAbajo {
            from {
              opacity: 0;
              transform: translateY(50px);
            }

            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .hero-animacion {
            opacity: 0;
            animation: aparecerDesdeAbajo 0.8s ease-out forwards;
          }

          .hero-foto {
            animation-delay: 0.1s;
          }

          .hero-saludo {
            animation-delay: 0.4s;
          }

          .hero-nombre {
            animation-delay: 0.6s;
          }

          .hero-titulo {
            animation-delay: 0.8s;
          }

          .hero-botones {
            animation-delay: 1s;
          }

          @media (prefers-reduced-motion: reduce) {
            .hero-animacion {
              opacity: 1;
              animation: none;
            }
          }
        `}
      </style>

      <section
        id="inicio"
        className="relative flex min-h-[106vh] items-center overflow-hidden pt-24 pb-0 sm:pt-24"
      >
        <div className="mx-auto flex w-full max-w-[1300px] flex-col items-center justify-center gap-8 pb-20 xl:flex-row xl:justify-between xl:gap-16">
          <div className="order-2 w-full text-center xl:order-1 xl:w-[70%] xl:text-left">
            <p className="hero-animacion hero-saludo pt-3 text-base font-medium uppercase tracking-[4px] text-black sm:text-lg sm:tracking-[5px]">
              Hola, soy
            </p>

            <h1 className="hero-animacion hero-nombre mt-2 text-[42px] font-black leading-[1.05] tracking-[-2px] sm:text-[52px] md:text-[58px] xl:text-[75px]">
              <span className="bg-gradient-to-b from-red-400 via-red-600 to-red-800 bg-clip-text text-transparent">
                Mauricio
              </span>

              <br />

              <span className="bg-gradient-to-b from-yellow-300 via-yellow-500 to-yellow-700 bg-clip-text text-transparent">
                Fernández
              </span>{" "}

              <span className="bg-gradient-to-b from-[#4a527f] via-[#1c2143] to-[#10142c] bg-clip-text text-transparent">
                Licciardi
              </span>
            </h1>

            <h2 className="hero-animacion hero-titulo mt-3 text-[18px] font-semibold text-black sm:text-[24px] md:text-[28px] xl:text-[30px]">
              Técnico Universitario en Programación
            </h2>

            <div className="hero-animacion hero-botones mt-6 flex w-full flex-col items-center justify-center gap-3 sm:flex-row xl:justify-start">
              <button
                onClick={irAProyectos}
                className="flex w-full max-w-[360px] items-center justify-center gap-2 rounded-full border-2 border-[#1c2143] bg-[#1c2143] px-7 py-2.5 text-base font-bold text-white shadow-[0_0_30px_rgba(28,33,67,0.25)] transition duration-300 hover:-translate-y-1 hover:bg-transparent hover:text-[#1c2143] hover:shadow-[0_0_40px_rgba(28,33,67,0.25)] sm:w-auto sm:max-w-none sm:gap-3 sm:px-8 sm:py-3 sm:text-lg"
              >
                Ver proyectos
                <ExternalLink size={19} />
              </button>

              <a
                href="/Mauricio Fernández Licciardi CV.pdf"
                download="Mauricio Fernández Licciardi-CV.pdf"
                className="flex w-full max-w-[360px] items-center justify-center gap-2 rounded-full border-2 border-[#1c2143] bg-transparent px-7 py-2.5 text-base font-bold text-[#1c2143] transition duration-300 hover:-translate-y-1 hover:bg-[#1c2143] hover:text-white sm:w-auto sm:max-w-none sm:gap-3 sm:px-8 sm:py-3 sm:text-lg"
              >
                Descargar CV
                <Download size={19} />
              </a>
            </div>
          </div>

          <div className="order-1 flex w-full justify-center xl:order-2 xl:w-[50%]">
            <div className="hero-animacion hero-foto relative flex items-center justify-center">
              <div className="absolute h-[220px] w-[220px] rotate-45 rounded-[30px] border-2 border-[#2f5972]/40 bg-gradient-to-br from-[#1c2143]/20 to-[#003b5c]/10 sm:h-[300px] sm:w-[300px] md:h-[360px] md:w-[360px] xl:h-[420px] xl:w-[420px]" />

              <img
                src="/foto2.jpg"
                alt="Mauricio Fernández Licciardi"
                className="relative aspect-square h-[240px] w-[240px] rounded-full border-4 border-[#1c2143] object-cover shadow-[0_0_60px_rgba(28,33,67,0.3)] sm:h-[320px] sm:w-[320px] md:h-[380px] md:w-[380px] xl:h-[480px] xl:w-[480px]"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;